import qs from 'qs';

export const navigateToRetirementSideBySide = (
  clientId: string,
  planIds: string[],
  goalId: string,
) => {
  ADV.util.Router.go2('RetirementSideBySide', {
    clientId,
    planIds: qs.stringify({ planIds }, { arrayFormat: 'repeat' }),
    goalId,
  });
};
